import apiClient from './apiClient';

/**
 * Referral submissions from standard user accounts (newest first).
 * @returns {Promise<Array>}
 */
export async function fetchReferralRequests() {
  const { data } = await apiClient.get('admin/referrals/requests');
  return Array.isArray(data) ? data : [];
}

/** @returns {Promise<{ sourceEmail: string, serverSendEnabled?: boolean }>} */
export async function fetchReferralMailSettings() {
  const { data } = await apiClient.get('admin/referrals/mail-settings');
  return data || { sourceEmail: '', serverSendEnabled: false };
}

/**
 * @param {{ requestId: number, company: string, panelContactId: number }} body
 * @returns {Promise<{ toEmail: string, sourceEmail: string, subject: string, body: string, mailto: string }>}
 */
export async function fetchReferralSendPreview(body) {
  const { data } = await apiClient.post('admin/referrals/send-preview', body);
  return data;
}

/**
 * @param {{ requestId: number, company: string, panelContactId: number }} body
 */
export async function sendReferralEmail(body) {
  await apiClient.post('admin/referrals/send', body);
}

/** @param {{ requestId: number, company: string, panelContactId?: number }} body */
export async function markReferralSent(body) {
  await apiClient.post('admin/referrals/mark-sent', body);
}

export const REFERRAL_SENT_STATUS = 'Referral Sent';
